import { Address } from "@/models/address/address";
import { OrderStatus, OrderType } from "@/models/order/helpers";
import { LineItem } from "@/models/order/order";
import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import { OrderState } from "./types";

export const defaultState: OrderState = {
  _id: null,
  // Declared here (not just set by mutations) so Vue 2 makes them reactive from
  // init. A property first added to state after init isn't reactive — the
  // edit-mode banner then reads a stale value until a page refresh rehydrates
  // state with the key present. Applies to the NS-identity fields, the customer
  // block below, and `created_type`; the mutations that clear any of them
  // assign `undefined` rather than `delete`, which would drop the reactivity
  // this line exists to establish.
  netsuite_id: undefined,
  netsuite_tran_id: undefined,
  created_type: undefined,
  status: OrderStatus.Open,
  type: OrderType.Quote,
  status_log: [],
  customer_id: "",
  customer_name: "",
  customer_netsuite_id: undefined,
  customer_netsuite_contact_id: undefined,
  customer_netsuite_payment_terms_id: undefined,
  customer_netsuite_price_level_id: undefined,
  customer_netsuite_price_level_discount: undefined,
  notes: "",
  // Every optional field is spelled out here rather than left to appear on
  // first write. Checkout binds these sections with `v-bind.sync`, which only
  // wires an `update:<key>` listener for keys the object already has — a
  // section reset from these defaults with `title`/`contact_id`/`send_email` or
  // `request_freight_estimate` missing silently swallows every update for them
  // (FUPOF-191). It also keeps the keys reactive for direct writes.
  contact_details: {
    quote_name: "",
    company_name: "",
    title: "",
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    contact_id: null,
    send_email: false
  },
  shipping_details: {
    label: "",
    addressee: "",
    attention: "",
    address: {} as Address,
    phone: "",
    email: "",
    freight_instructions: "",
    request_freight_estimate: null
  },
  billing_details: {
    addressee: "",
    attention: "",
    address: {} as Address,
    phone: "",
    email: ""
  },
  payment_details: {
    method: undefined
  },
  items: [] as LineItem[],
  draft_id: null,
  draft_status: null,
  drift_report: null
};

const state = { ...defaultState };

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
